import { Dimensions } from './dimensions.model';
import { SizeUnit } from './size-unit.model';
import { WeightUnits } from './weight-units.model';

export class ShippingPackages {
  weight: number;
  dimensions: Dimensions;
  isValid = false;
  width: number;
  height: number;
  length: number;

  constructor(
    public id: number,
    public quantity: number,
    public maxQuantity: number,
    public quantitySelectEnabled: boolean,
    dimensionUnit: SizeUnit,
    public weightUnit: WeightUnits) {
    this.dimensions = new Dimensions(dimensionUnit);
  }
}
